export const REQUESTED_WORKPLACE_YEAR_END_BALANCE =
  'REQUESTED_WORKPLACE_YEAR_END_BALANCE';
export const requestedWorkplaceYearEndBalanceData = () => {
  return {
    type: REQUESTED_WORKPLACE_YEAR_END_BALANCE
  };
};

export const RECEIVED_WORKPLACE_YEAR_END_BALANCE =
  'RECEIVED_WORKPLACE_YEAR_END_BALANCE';
export const receivedWorkplaceYearEndBalanceData = (payload) => {
  return {
    type: RECEIVED_WORKPLACE_YEAR_END_BALANCE,
    payload
  };
};

export const ERROR_WORKPLACE_YEAR_END_BALANCE =
  'ERROR_WORKPLACE_YEAR_END_BALANCE';
export const errorWorkplaceYearEndBalanceData = () => {
  return {
    type: ERROR_WORKPLACE_YEAR_END_BALANCE
  };
};
